import {
    GET_SELECTED_LEAGUE_LOADING,
    GET_SELECTED_LEAGUE_ERROR,
    GET_SELECTED_LEAGUE_SUCCESS,
  } from "../../../constant/actionTypes";
  
  const initialState = { loading: false, status: {} };
  
  const getSelectedLeagueReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_SELECTED_LEAGUE_LOADING: {
        let obj = { loading: true };
        return obj;
      }
      case GET_SELECTED_LEAGUE_SUCCESS: {
        let obj = { loading: false, status: action.response };
        return obj;
      }
      case GET_SELECTED_LEAGUE_ERROR: {
        let obj = { loading: false, status: action.response };
        return obj;
      }
  
      default:
        return state;
    }
  };
  
  export default getSelectedLeagueReducer;
  